<div class="flex flex-col items-center content-center justify-center gap-2 text-center">
	<img src="/assets/images/logo.jpg" alt="logo" class="h-[100px] flex justify-center content-center items-center m-auto mb-2">
	<h3 class="text-lg font-semibold popup-text">
		Important Notice About Payments
	</h3>
	<p class="text-base font-medium text-justify popup-text">
		We want to let our customers know that our payment gateway is currently unavailable.
		<br />
		<br />
		All recent payments were securely processed through our UK-based partner, Dynamic Payment Services Limited (DPSL). However, this caused some confusion for a few customers who didn’t recognize the name on their bank statements. As a result, our payment provider has temporarily suspended our service.
		<br />
		<br />
		We’re actively working to integrate a new payment solution and expect to restore full checkout functionality very soon.
		<br />
		<br />
		Rest assured, all orders have been shipped, and we’re here to help with any questions in the meantime.
		<br />
		<br />
		Thank you for your understanding and continued support.
		Contact us: info&#64;starsandstripesseed.com
	</p>
</div>